import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import './commonClass.css';
import Header from './components/layouts/Header';
import Sidebar from './components/layouts/Sidebar';
import { mainRoutes } from './routes/AppRoutes';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import Footer from './components/layouts/Footer';
import { changeLanguage } from './actions/langauge';
import ChatwootWidget from './components/ChatwootWidget'; // Ensure this path is correct
function App() {
  const { isLoggedIn } = useSelector((state) => state.auth);
  const language = useSelector((state) => state.languageReducer.language);
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState(location.pathname);
  const dispatch = useDispatch();
  const ignoredPaths = [
    '/login',
    '/reset-password',
    '/profile',
    '/set-new-password-social',
    '/set-new-password',
  ];

  useEffect(() => {
    setCurrentPath(location.pathname);

    const userLang = navigator.language || navigator.userLanguage;
    if (isLoggedIn) {
      document.documentElement.lang = language;
      dispatch(changeLanguage(language));
    } else {
      const lang = userLang === 'nl' ? 'nl' : 'en';
      document.documentElement.lang = lang;
      dispatch(changeLanguage(lang));
    }
  }, [location.pathname, isLoggedIn, language, dispatch]);

  useEffect(() => {
    const removeTags = () => {
      const isIgnoredPath = ignoredPaths.some((path) =>
        location.pathname.includes(path),
      );

      if (isIgnoredPath) {
        const gtmScripts = document.querySelector(
          'script[src*="googletagmanager"]',
        );
        if (gtmScripts) {
          gtmScripts.remove();
        }
        const gtmScript = document.querySelector(
          'script[src="https://www.googletagmanager.com/gtm.js?id=GTM-5G5C94CT"]',
        );
        // Remove the script tag if it exists
        if (gtmScript) {
          gtmScript.parentNode.removeChild(gtmScript);
        }
      } else {
        const gtmScript = document.querySelector(
          'script[src="https://www.googletagmanager.com/gtm.js?id=GTM-5G5C94CT"]',
        );
        if (!gtmScript) {
          const script = document.createElement('script');
          script.id = 'gtm-script';
          script.innerHTML = `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-5G5C94CT');
          `;
          document.head.appendChild(script);
        }
      }
    };
    // Execute the removal function
    removeTags();
  }, [location.pathname]);
  const ignorePath = 'set-new-password';

  const generateRoute = ({ isGuarded, ...route }, key) => {
    if (isGuarded) {
      return (
        <Route
          key={key}
          path={route.path}
          exact
          element={
            <RequireAuth isLoggedIn={isLoggedIn}>{route.element}</RequireAuth>
          }
        />
      );
    }

    return (
      <Route
        exact
        key={key}
        path={route.path}
        element={
          isLoggedIn && !route.path.includes(ignorePath) ? (
            <Navigate to="/" replace />
          ) : (
            route.element
          )
        }
      />
    );
  };
  window.scrollTo(0, 0); //for demo
  return (
    <div
      className={
        isLoggedIn &&
        currentPath != null &&
        currentPath.includes(ignorePath) === false
          ? 'px-4 pb-4 bg-white dark:bg-slate-900'
          : ''
      }
    >
      {isLoggedIn &&
        currentPath != null &&
        currentPath.includes(ignorePath) === false && <Header />}
      <div
        className={
          isLoggedIn &&
          currentPath != null &&
          currentPath.includes(ignorePath) === false
            ? 'flex'
            : ''
        }
      >
        {isLoggedIn &&
          currentPath != null &&
          currentPath.includes(ignorePath) === false && <Sidebar />}
        <div className={isLoggedIn && currentPath != null ? 'w-full' : ''}>
          <Routes>
            {mainRoutes.map((route, index) => generateRoute(route, index))}
          </Routes>
          {isLoggedIn && <ChatwootWidget />}
          <Footer />
        </div>
      </div>
    </div>
  );
}

const RequireAuth = ({ children, isLoggedIn }) => {
  if (!isLoggedIn) return <Navigate to="/signup" replace />;

  return children;
};

export default App;
